import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'
import * as Actions from 'actions/persona_library'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  selectedPersona: {
    id: null,
    name: '',
    description: '',
    promptIds: []
  },
  personaDialogOpen: false,
  requestRunning: false
})

export default handleActions({
  [Actions.openPersonaDialog]: (state, { payload }) => {
    let selectedPersona = initialState.get('selectedPersona')

    if (payload) {
      selectedPersona = payload
    }

    return state.set('selectedPersona', selectedPersona)
      .set('personaDialogOpen', true)
  },
  [Actions.closePersonaDialog]: state => state.set('personaDialogOpen', false),
  [Actions.setSelectedPersonaField]: (state, { payload: { key, value } }) => state.setIn(['selectedPersona', key], value),
  [combineActions(
    Actions.createPersonaStart,
    Actions.updatePersonaStart,
    Actions.generatePersonasStart
  )]: state => state.set('requestRunning', true),
  [combineActions(
    Actions.createPersonaSuccess,
    Actions.createPersonaError,
    Actions.updatePersonaSuccess,
    Actions.updatePersonaError,
    Actions.generatePersonasSuccess,
    Actions.generatePersonasError
  )]: state => state.set('requestRunning', false),
  [combineActions(
    Actions.createPersonaSuccess,
    Actions.updatePersonaSuccess
  )]: state => state.set('personaDialogOpen', false)
    .set('selectedPersona', initialState.get('selectedPersona')),
  [AppActions.resetState]: () => initialState
}, initialState)
